import token_formatter from 'common/token_formatter'
import annotationApiService from 'services/annotation_api_service'

const state = {
  id: 0,
  numeroTol: '',
  clazz: '',
  headerFields: [],
  metadataFields: [],
  indiceFields: [],
  bodyFields: [],
  fileFields: [],
  searchParagraphsProcessed: 0,
  searching: false,
  searchText: '',
  selectedConcept: {},
  annotations: [],
  annotationsLoaded: false
}

const getters = {
  totalParagraphs(state) {
    return (state.bodyFields || []).reduce((acc, field) => {
      return acc + field.value.length
    }, 0)
  },
  textsToHighlight(state) {
    const result = (() => {
      if (state.selectedConcept && state.selectedConcept.terms) {
        return state.selectedConcept.terms
      }
      if (state.searchText) {
        return token_formatter.format_and_split_tokens(state.searchText.split(' '))
      }
      return []
    })()
    return result
  },
  hasToStemHighlight(state) {
    return state.selectedConcept && state.selectedConcept.terms ? false : true
  },
  annotationsForParagraph: (state) => (sectionId, paragraphIndex) => {
    return state.annotations.filter(a => {
      if (!a.isTableAnnotation) {
        return a.sectionId === sectionId && a.paragraphIndex === paragraphIndex
      }

      if (a.tableId) {
        return a.tableId.startsWith(`${sectionId}-${paragraphIndex}-t`)
      }
      return false
    })
  },
  allAnnotations: (state) => state.annotations
}

const mutations = {
  setId(state, data) { state.id = data },
  setNumeroTol(state, data) { state.numeroTol = data },
  setClazz(state, data) { state.clazz = data },
  setHeaderFields(state, data) { state.headerFields = data },
  setMetadataFields(state, data) { state.metadataFields = data },
  setIndiceFields(state, data) { state.indiceFields = data },
  setBodyFields(state, data) { state.bodyFields = data },
  setFileFields(state, data) { state.fileFields = data },
  setSearchText(state, data) {
    state.searchText = data
    state.selectedConcept = {}
  },
  setSelectedConcept(state, data) {
    state.selectedConcept = data
    state.searchText = ''
  },
  increaseParagraphsProcessed(state) {
    state.searchParagraphsProcessed++
    if (state.searchParagraphsProcessed == getters.totalParagraphs(state)) {
      state.searching = false
    }
  },
  initSearch(state) {
    state.searching = true
    state.searchParagraphsProcessed = 0
  },
  setAnnotations(state, data) {
    state.annotations = data
    state.annotationsLoaded = true
  },
  addAnnotation(state, annotation) {
    state.annotations.push(annotation)
  },
  updateAnnotation(state, { id, updates }) {
    const index = state.annotations.findIndex(a => a.id === id)
    if (index !== -1) {
      Object.assign(state.annotations[index], updates)
    }
  },
  removeAnnotation(state, id) {
    const index = state.annotations.findIndex(a => a.id === id)
    if (index !== -1) {
      state.annotations.splice(index, 1)
    }
  },
  clearAnnotations(state) {
    state.annotations = []
    state.annotationsLoaded = false
  }
}

const actions = {
  async loadAnnotations({ commit, state }, documentId = null) {
    const id = documentId || state.id
    if (!id || state.annotationsLoaded) {
      return
    }

    try {
      const annotations = await annotationApiService.fetchAnnotations(id)
      commit('setAnnotations', annotations)
    } catch (error) {
      commit('setAnnotations', [])
    }
  },

  async createAnnotation({ commit }, annotation) {
    try {
      const result = await annotationApiService.createAnnotation(annotation)
      commit('addAnnotation', result)
      return result
    } catch (error) {
      throw error
    }
  },

  async updateAnnotation({ commit, state }, { id, updates }) {
    try {
      await annotationApiService.updateAnnotation(id, state.id, updates)
      commit('updateAnnotation', { id, updates })
    } catch (error) {
      throw error
    }
  },

  async deleteAnnotation({ commit, state }, id) {
    try {
      await annotationApiService.deleteAnnotation(id, state.id)
      commit('removeAnnotation', id)
    } catch (error) {
      throw error
    }
  }
}

export default {
  namespaced: true,
  name: 'document',
  state,
  getters,
  mutations,
  actions
}
